import React, { useState, useEffect } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { Button, TextField, InputAdornment, IconButton, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import SettingsIcon from '@mui/icons-material/Settings';
import useAuth from '../../../hooks/useAuth';

// import {useNavigate} from 'react-router-dom'


import './settings.scss';

const UPLOAD_URL = '/settings';
const USER_URL = '/users';

const Settings = () => {
  // const history = useNavigate()
  // const navigate = useNavigate();
  const { setAuth } = useAuth()

  const axiosPrivate = useAxiosPrivate();
  const [user, setUser] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileLogo, setSelectedFileLogo] = useState(null);
  // const [imageUrl, setImageUrl] = useState('');
  // const [imageUrlLogo, setImageUrlLogo] = useState('');

  const [open, setOpen] = React.useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
  
    setOpen(false);
  };
  

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };
  const handleFileChangeLogo = (event) => {
    const file = event.target.files[0];
    setSelectedFileLogo(file);
  };

  const peticionPut = async () => {
    try {
      const response = await axiosPrivate.put(USER_URL + "/" + user._id, user);
      console.log(response.data.userUpdated)
      setAuth(prevState=>({
        ...prevState,
        razonSocial: response.data.userUpdated.razonSocial,
        address: response.data.userUpdated.address,
        phone: response.data.userUpdated.phone,
        username: response.data.userUpdated.username,
      }));
      setOpen(true);
      // console.log("Usuario actualizado con éxito", response.data);
    } catch (error) {
      console.error("Error al actualizar el usuario", error);
    }
  };

  const peticionGet = async () => {
    await axiosPrivate.get(USER_URL)
      .then((response) => {
        const userData = response.data[0];
        setUser({
          _id: userData._id,
          fullName: userData.fullName,
          companyName: userData.companyName,
          email: userData.email,
          phone: userData.phone,
          razonSocial: userData.razonSocial,
          address: userData.address,
          nit: userData.nit,
          username: userData.username,
          password: userData.password
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

const handleUpload = () => {
    const formData = new FormData();
    formData.append('image', selectedFile);
    console.log(formData)  
    axiosPrivate
      .put(`${UPLOAD_URL}/${user._id}?valor=${'avt'}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
   
          // setImageUrl(response.data.imageUrl);
          const urlAvt = response.data.imageUrl
          setAuth(prevState=>({
            ...prevState,
            urlAvt: urlAvt,
          }));
          setOpen(true);
        
      })
      .catch((error) => {
        console.error('Error uploading image: ', error);
      });
  };
const handleUploadLogo = () => {
    const formDataLogo = new FormData();
    formDataLogo.append('image', selectedFileLogo);
 
    axiosPrivate
      .put(`${UPLOAD_URL}/${user._id}?valor=${'logo'}`, formDataLogo, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        // setImageUrlLogo(response.data.imageUrl);
        // peticionGet()
        const urlLogo = response.data.imageUrl
        setAuth(prevState=>({
          ...prevState,
          urlLogo: urlLogo,
        }));
        setOpen(true);
       
   

      })
      .catch((error) => {
        console.error('Error uploading image: ', error);
      });
  };  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    peticionGet();
  }, []);

  const action = (
    <>
      <Button color="secondary" size="small" onClick={handleClose}>
        DESHACER
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );

  return (
    <div className="settings-container">
      <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={handleClose}
        message="Actualizado con Exito!"
        action={action}
       
        // action={action}
      />
      <h3><SettingsIcon /> AJUSTES GENERALES</h3>
   


      <Accordion expanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="empresa-panel"
          id="empresa-header"
        >
          <h3 className="tituloModal">Datos de Empresa:</h3>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={(e) => e.preventDefault()}>
            <TextField
              className="TextField"
              label="Nombre Completo:"
              name="fullName"
              onChange={handleChange}
              value={user.fullName}
              required
              // variant="outlined"
              fullWidth
              focused
              style={{ marginBottom: '16px' }} // Espacio vertical
              // color="secondary" 
              variant="filled"        
            />
            <TextField
              className="TextField"
              label="Nombre de Empresa:"
              name="companyName"
              onChange={handleChange}
              value={user.companyName}
              required
              variant="filled"
              fullWidth
              focused
              style={{ marginBottom: '16px' }} // Espacio vertical
            />
            <TextField
              className="TextField"
              label="Email:"
              name="email"
              onChange={handleChange}
              value={user.email}
              required
              variant="filled"
              fullWidth
              focused
              style={{ marginBottom: '16px' }} // Espacio vertical
            />
            <TextField
              className="TextField"
              label="Telefono (Incluir código de país):"
              name="phone"
              onChange={handleChange}
              value={user.phone}
              required
              variant="filled"
              fullWidth
              focused
              style={{ marginBottom: '16px' }} // Espacio vertical
            />
            <TextField
              className="TextField"
              label="Razón Social:"
              name="razonSocial"
              onChange={handleChange}
              value={user.razonSocial}
              required
              variant="filled"
              fullWidth
              focused
              style={{ marginBottom: '16px' }} // Espacio vertical
            />
            <TextField
              className="TextField"
              label="Ciudad, País y Dirección:"
              name="address"
              onChange={handleChange}
              value={user.address}
              required
              variant="filled"
              fullWidth
              focused
              style={{ marginBottom: '16px' }} // Espacio vertical
            />
            {/* <TextField
              className="TextField"
              label="NIT:"
              name="nit"
              onChange={handleChange}
              value={user.nit}
              variant="filled"
              fullWidth
              focused
            /> */}
          </form>
        </AccordionDetails>
      </Accordion>
      {/* <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="accesos-panel"
          id="accesos-header"
        >
          <h3 className="tituloModal">Cambiar Usuario y Contraseña:</h3>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={(e) => e.preventDefault()}>
            <TextField
              className="TextField"
              label="Username:"
              name="username"
              onChange={handleChange}
              value={user.username}
              required
              fullWidth
              variant="outlined"
              focused
              style={{ marginBottom: '16px' }} // Espacio vertical
              color='secondary'
            />
            <TextField
              className="TextField"
              label="Password:"
              name="password"
              onChange={handleChange}
              type={showPassword ? 'text' : 'password'}
              value={user.password || ''}
              fullWidth
              variant="outlined"
              color='secondary'
              focused
              style={{ marginBottom: '16px' }} // Espacio vertical
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </form>
        </AccordionDetails>
      </Accordion> */}
      <br />
      <div className="button-container">
        <Button variant="contained" className="custom-button" color="primary" onClick={peticionPut} type="submit">
          Actualizar
        </Button>
        {/* <Button variant="contained" className="custom-button">Cancelar</Button> */}
      </div>
            {/* UPDATE AVATAR */}
            <div>
      <br />
        <h3>Avatar:</h3>
     
        <div className="file-upload">
          <label htmlFor="fileInput" className="custom-square">
            {selectedFile ? (
              <img src={URL.createObjectURL(selectedFile)} alt="Selected" />
            ) : (
              <span>Seleccionar Imagen</span>
            )}
            <input type="file" id="fileInput" onChange={handleFileChange} />
          </label>
          <button className="upload-button" onClick={handleUpload}>
            Subir Imagen
          </button>
        </div>
        {/* {imageUrl && (
          <div className="image-preview">
            <h3>Imagen subida!</h3>
            <img src={`http://localhost:8000/upload/images/${imageUrl}`} alt="Uploaded" />
          </div>
        )} */}
      </div>

       {/* UPDATE LOGO    */}
       <div>
        <h3>Logo:</h3>
        <div className="file-upload">
          <label htmlFor="fileInputLogo" className="custom-square">
            {selectedFileLogo ? (
              <img src={URL.createObjectURL(selectedFileLogo)} alt="Selected" />
            ) : (
              <span>Seleccionar Imagen</span>
            )}
            <input type="file" id="fileInputLogo" onChange={handleFileChangeLogo} />
          </label>
          <button className="upload-button" onClick={handleUploadLogo}>
            Subir Imagen
          </button>
        </div>
        {/* {imageUrlLogo && (
          <div className="image-preview">
            <h3>Imagen subida!</h3>
          </div>
        )} */}
      </div> 
    </div>
  );
};

export default Settings;
